import { InvitationColumn } from '../types/invitation.type';

export const INVITATIONS_LIST_COLUMNS: InvitationColumn[] = [
  'sender',
  'participants',
  'totalPaid',
  'createdAt',
  'deliveryDate',
];

export const SENDER_INVITATIONS_COLUMNS: InvitationColumn[] = [
  'createdAt',
  'deliveryDate',
  'participants',
  'totalPaid',
];
